{
  "meta": {
    "industry": "SaaS",
    "fiscalYear": "FY2026",
    "currency": "USD"
  },
  "timing": {
    "typingSpeedMs": 32,
    "thinkingMs": 1300,
    "nudgeDelayMs": 600
  },
  "charts": {
    "nrrComparison": {
      "type": "bar",
      "title": "NRR: Current vs 90 Days Ago",
      "containerClass": "chartCardSmall",
      "data": [
        { "period": "90 Days Ago", "nrr": 114 },
        { "period": "Current", "nrr": 95 }
      ],
      "xKey": "period",
      "yKey": "nrr",
      "barColor": "hsl(202, 100%, 50%)",
      "barRadius": [4, 4, 0, 0],
      "height": 180,
      "tooltip": { "suffix": "%", "decimals": 0 },
      "legend": { "show": true },
      "barName": "NRR (%)"
    },
    "nrrDrivers": {
      "type": "bar-horizontal",
      "title": "NRR Drivers: Contraction vs Expansion (pp)",
      "containerClass": "chartCard",
      "data": [
        { "driver": "EMEA Contraction", "impactPp": -32 },
        { "driver": "Expansion", "impactPp": 13 }
      ],
      "categoryKey": "driver",
      "valueKey": "impactPp",
      "barColor": "hsl(202, 100%, 50%)",
      "barRadius": [0, 4, 4, 0],
      "height": 230,
      "yAxisWidth": 130,
      "tooltip": { "suffix": "pp", "decimals": 0 }
    },
    "nrrDriverMix": {
      "type": "pie",
      "title": "Driver Magnitude Mix (Absolute Impact, pp)",
      "containerClass": "chartCardSmall",
      "data": [
        { "name": "Contraction", "value": 32, "color": "hsl(0, 84%, 60%)" },
        { "name": "Expansion", "value": 13, "color": "hsl(142, 76%, 36%)" }
      ],
      "tooltip": { "suffix": "pp", "decimals": 0, "includeLabel": true },
      "layout": "side",
      "flexClass": "chartFlex chartHeight44",
      "legend": {
        "size": "small",
        "items": [
          { "text": "Contraction: -32pp", "color": "hsl(0, 84%, 60%)" },
          { "text": "Expansion: +13pp", "color": "hsl(142, 76%, 36%)" }
        ],
        "footer": "Net NRR change: -19pp"
      }
    }
  },
  "conversations": [
    {
      "question": "what is our current nrr, compared to 90 days ago",
      "pauseAfterResponseMs": 2600,
      "blocks": [
        {
          "type": "chart",
          "chartId": "nrrComparison",
          "delayMs": 1250
        },
        {
          "type": "heading",
          "text": "NRR Snapshot",
          "delayMs": 0
        },
        {
          "type": "list",
          "delayMs": 0,
          "items": [
            "Current NRR: 95%",
            "NRR 90 Days Ago: 114%",
            "Net Change: -19pp"
          ]
        },
        {
          "type": "paragraph",
          "delayMs": 0,
          "text": "Current NRR is 95%, compared to 114% ninety days ago, for a net change of -19 percentage points."
        }
      ]
    },
    {
      "question": "what is driving that nrr movement",
      "blocks": [
        {
          "type": "chart",
          "chartId": "nrrDrivers",
          "delayMs": 1250
        },
        {
          "type": "chart",
          "chartId": "nrrDriverMix",
          "delayMs": 2100
        },
        {
          "type": "heading",
          "text": "NRR Driver Analysis",
          "delayMs": 1250
        },
        {
          "type": "list",
          "delayMs": 0,
          "items": [
            "EMEA Contraction Impact: -32pp",
            "Expansion Impact: +13pp",
            "Net NRR Change: -19pp"
          ]
        },
        {
          "type": "paragraph",
          "delayMs": 0,
          "text": "Current NRR is 95%, compared to 114% ninety days ago. The biggest negative driver was a large contraction in EMEA, partially offset by expansion in other segments."
        },
        {
          "type": "paragraph",
          "emphasis": "italic",
          "delayMs": 600,
          "text": "Do you want to dive into feature adoption and customer health for other EMEA customers?"
        }
      ]
    }
  ]
}